import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=48032546&scoped=true&"
import script from "./TableHeader.vue?vue&type=script&lang=js&"
export * from "./TableHeader.vue?vue&type=script&lang=js&"
import style0 from "@/design/TableHeader.css?vue&type=style&index=0&id=48032546&prod&scoped=true&lang=css&"
import style1 from "./TableHeader.vue?vue&type=style&index=1&id=48032546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48032546",
  null
  
)

export default component.exports